import React, { useCallback, useMemo, useState } from 'react';
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const CustomerTab = ({ data, onDataChange, additionalExpenses, state }) => {
  const classes = useStyles();
  const [editedData, setEditedData] = useState(null);
  const total = state?.data?.transactions?.reduce((acc, transaction) => acc + (transaction.value || 0), 0) || 0;
  const currentData = editedData || data;

  const expenses = useMemo(() => {
    return additionalExpenses?.reduce((acc, client) => acc+(client?.suma || 0),0);
  }, [additionalExpenses]);

  const grandTotals = useMemo(() => {
    return currentData.reduce((acc, client) => ({
      qtyProduct: acc.qtyProduct + client.clientTotals.qtyProduct,
      price: acc.price + client.clientTotals.price,
      discount: acc.discount + client.clientTotals.discount,
      suma: acc.suma + client.clientTotals.suma,
      priceCalc: acc.priceCalc + client.clientTotals.priceCalc,
      discountPrice: acc.discountPrice + client.clientTotals.discountPrice
    }), {
      qtyProduct: 0,
      price: 0,
      discount: 0,
      suma: 0,
      priceCalc: 0,
      discountPrice: 0
    });
  }, [currentData]);



  const formatNumber = useCallback((value) => {
    return new Intl.NumberFormat('uk-UA', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(value || 0);
  }, []);

  const formatDefects = useCallback((defects) => {
    return defects && defects.length > 0 ? defects.join('/\n') : '';
  }, []);

  const formatRaintake = useCallback((raintake) => {
    return raintake?.includes('reintake') ? 'перезабір' : '';
  }, []);

  const formatResults = useCallback((results) => {
    return results && results.length > 0 ? results.join('/\n') : '';
  }, []);

  return (
    <>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '80px' }}>Дата</TableCell>
              <TableCell style={{ width: '100px' }}>№ Замовлення</TableCell>
              <TableCell style={{ width: '60px' }}>Код</TableCell>
              <TableCell style={{ width: '300px' }}>Найменування послуги</TableCell>
              <TableCell style={{ width: '70px' }}>Кількість</TableCell>
              <TableCell style={{ width: '100px' }}>Ціна, згідно прайсу, грн</TableCell>
              <TableCell style={{ width: '80px' }}>Бонус</TableCell>
              <TableCell style={{ width: '100px' }}>Сума до оплати</TableCell>
              <TableCell style={{ width: '100px' }}>Ціна розрахунку</TableCell>
              <TableCell style={{ width: '100px' }}>Сума знижки</TableCell>
              <TableCell style={{ width: '80px' }}>Брак</TableCell>
              <TableCell style={{ width: '80px' }}>Перезабір</TableCell>
              <TableCell style={{ width: '80px' }}>Результат</TableCell>
              <TableCell style={{ width: '80px' }}>Нотатка</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow className={classes.grandTotalRow}>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell><strong>Загальна сума:</strong></TableCell>
              <TableCell align="center"><strong>{grandTotals.qtyProduct}</strong></TableCell>
              <TableCell align="right"><strong>{formatNumber(grandTotals.price)}</strong></TableCell>
              <TableCell align="right"><strong>{formatNumber(grandTotals.discount)}</strong></TableCell>
              <TableCell align="right"><strong>{formatNumber(grandTotals.suma)}</strong></TableCell>
              <TableCell align="right"><strong>{formatNumber(grandTotals.priceCalc)}</strong></TableCell>
              <TableCell align="right"><strong>{formatNumber(grandTotals.discountPrice)}</strong></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
              <TableCell></TableCell>
            </TableRow>
            {currentData.map((clientGroup, clientIndex) => (
              <React.Fragment key={`client-${clientIndex}`}>
                <TableRow className={classes.clientRow}>
                  <TableCell colSpan={14}>
                    {clientGroup.client} / {clientGroup.address} / {clientGroup.birthday}
                  </TableCell>
                </TableRow>

                {clientGroup.items.map((item, itemIndex) => (
                  <TableRow
                    key={`item-${clientIndex}-${itemIndex}`}
                    className={item.hasError ? classes.errorRow : item.hasRaintake
                        ? classes.raintakeRow
                        : classes.dataRow}
                  >
                    <TableCell>{item.date}</TableCell>
                    <TableCell>{item.orderNumber}</TableCell>
                    <TableCell>{item.code}</TableCell>
                    <TableCell>{item.product}</TableCell>
                    <TableCell align="center">{item.qtyProduct}</TableCell>
                    <TableCell align="right">{formatNumber(item.price)}</TableCell>
                    <TableCell align="right">
                      {/* <TextField
                        type="number"
                        value={item.discount || 0}
                        onChange={(e) => handleValueChange(clientIndex, itemIndex, 'discount', e.target.value)}
                        className={classes.editableCell}
                        size="small"
                        variant="outlined"
                        inputProps={{ min: 0, step: 0.01 }}
                      /> */}
                      {item.discount || 0}
                    </TableCell>
                    <TableCell align="right">
                      {/* <TextField
                        type="number"
                        value={item.suma || 0}
                        onChange={(e) => handleValueChange(clientIndex, itemIndex, 'suma', e.target.value)}
                        className={classes.editableCell}
                        size="small"
                        variant="outlined"
                        inputProps={{ min: 0, step: 0.01 }}
                      /> */}
                      {item.suma || 0}
                    </TableCell>
                    <TableCell align="right">
                      {/* <TextField
                        type="number"
                        value={item.priceCalc || 0}
                        onChange={(e) => handleValueChange(clientIndex, itemIndex, 'priceCalc', e.target.value)}
                        className={classes.editableCell}
                        size="small"
                        variant="outlined"
                        inputProps={{ min: 0, step: 0.01 }}
                      /> */}
                      {item.priceCalc || 0}
                    </TableCell>
                    <TableCell align="right">
                      {/* <TextField
                        type="number"
                        value={item.discountPrice || 0}
                        onChange={(e) => handleValueChange(clientIndex, itemIndex, 'discountPrice', e.target.value)}
                        className={classes.editableCell}
                        size="small"
                        variant="outlined"
                        inputProps={{ min: 0, step: 0.01 }}
                      /> */}
                      {item.discountPrice || 0}
                    </TableCell>
                    <TableCell style={{ whiteSpace: 'pre-wrap' }}>
                      {formatDefects(item.defectNotice)}
                    </TableCell>
                    <TableCell>{formatRaintake(item.raintake)}</TableCell>
                    <TableCell style={{ whiteSpace: 'pre-wrap' }}>
                      {formatResults(item.result)}
                    </TableCell>
                    <TableCell style={{ whiteSpace: 'pre-wrap' }}>
                      {item.note}
                    </TableCell>
                  </TableRow>
                ))}

                <TableRow className={classes.totalRow}>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell><strong>TOTAL:</strong></TableCell>
                  <TableCell align="center"><strong>{clientGroup.clientTotals.qtyProduct}</strong></TableCell>
                  <TableCell align="right"><strong>{formatNumber(clientGroup.clientTotals.price)}</strong></TableCell>
                  <TableCell align="right"><strong>{formatNumber(clientGroup.clientTotals.discount)}</strong></TableCell>
                  <TableCell align="right"><strong>{formatNumber(clientGroup.clientTotals.suma)}</strong></TableCell>
                  <TableCell align="right"><strong>{formatNumber(clientGroup.clientTotals.priceCalc)}</strong></TableCell>
                  <TableCell align="right"><strong>{formatNumber(clientGroup.clientTotals.discountPrice)}</strong></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>

                <TableRow>
                  <TableCell colSpan={14} style={{ padding: '4px', border: 'none' }}></TableCell>
                </TableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Box className={classes.summaryBox}>
        <Typography className={classes.summaryText} align="center">
          Загальна сума до розрахунку: {
            total.toLocaleString('uk-UA')
          // formatNumber(grandTotals.priceCalc+expenses)
          } ₴
        </Typography>
      </Box>
    </>
  );
};

export default CustomerTab;


const useStyles = makeStyles((theme) => ({
  tableContainer: {
    height: 'calc(100vh - 310px)',
        minHeight: '250px',

    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none'
    },
    "@media (max-width: 900px)": {
      height: 'calc(100vh - 280px)',
    }
  },
  table: {
    borderCollapse: 'collapse',
    height: 'max-content',
    '& .MuiTableCell-root': {
      fontSize: '11px',
      fontFamily: 'Arial, sans-serif',
      padding: '2px 4px',
      lineHeight: '1.2'
    },
    '& .MuiTableCell-head': {
      backgroundColor: '#DDDDDD',
      fontWeight: 'bold',
      textAlign: 'center',
      fontSize: '12px',
      padding: '4px',
      position: 'sticky',
      top: 0,
      zIndex: 100
    }
  },
  clientRow: {
    backgroundColor: '#f0f0f0',
    '& td': {
      fontWeight: 'bold',
      fontSize: '11px',
      backgroundColor: '#f0f0f0',
      border: '1px solid #000'
    }
  },
  dataRow: {
    '& td': {
      backgroundColor: '#ffffff'
    }
  },
  errorRow: {
    '& td': {
      backgroundColor: '#FFCCCC !important'
    }
  },
  raintakeRow: {
    '& td': {
      backgroundColor: '#ffd699 !important'
    }
  },
  totalRow: {
    '& td': {
      backgroundColor: '#f0f0f0',
      fontWeight: 'bold',
      border: '1px solid #000'
    }
  },
  grandTotalRow: {
    position: 'sticky',
    top: '-1px',
    zIndex: 50,
    '& td': {
      backgroundColor: '#DDDDDD',
      fontWeight: 'bold',
      fontSize: '12px'
    }
  },
  editableCell: {
    '& .MuiInputBase-root': {
      fontSize: '11px',
      fontFamily: 'Arial, sans-serif'
    },
    '& .MuiInputBase-input': {
      padding: '1px 3px',
      textAlign: 'right'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none'
      }
    }
  },
  textArea: {
    marginTop: theme.spacing(2),
  },
  summaryBox: {
    backgroundColor: '#e8f5e8',
    padding: theme.spacing(2),
    border: '2px solid #4caf50',
    borderRadius: 4,
    marginTop: theme.spacing(2)
  },
  summaryText: {
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: 'Arial, sans-serif'
  }
}));
